import type { HTMLAttributes } from "react";
import s from "./Stack.module.css";

export type StackGap = "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8";
export type StackDirection = "row" | "column";

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  gap?: StackGap;
  direction?: StackDirection;
}

export function Stack({ gap = "3", direction = "column", className, style, ...rest }: StackProps) {
  const classes = className ? `${s.root} ${className}` : s.root;
  return (
    <div
      className={classes}
      style={{ flexDirection: direction, gap: `var(--space-${gap})`, ...style }}
      {...rest}
    />
  );
}
